/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NewChapterModalState {
    isOpen: boolean;

    data: {
        documentId: number;
    } | null;
}

export interface NewChapterModalDispatchParams {
    documentId: number;
}

const initialState: NewChapterModalState = {
    isOpen: false,
    data: null,
};

export const newChapterModalSlice = createSlice({
    name: 'new-chapter-modal',
    initialState,
    reducers: {
        open(state: NewChapterModalState, action: PayloadAction<NewChapterModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: NewChapterModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
});
